export const config = {
    type: 'GROUP_INFO',
    title: '用户评论',
    defaultProps: {
        avatar: '',
        avatarSize: 32,
        avatarBorderRadius: 6,
        likes: 18,
        likesIconSize: 12,
        likeIconColor: '#333',
        title: '用户名',
        titleStyle: {
            color: '#000',
            backgroundColor: "transparent",
            fontSize: '16px',
            textAlign: 'left',
        },
        description: '评论内容说一说',
        descriptionStyle: {
            color: '#434343',
            backgroundColor: "transparent",
            fontSize: '16px',
            textHeight: '1.5',
        },
        style: {
            backgroundColor: "transparent",
            borderRadius: "0px",
            marginBottom: "0px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px",
            minHeight: "100px",
            padding: "15px",
        }
    },
    preview: {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px'
        },
        avatar: {
            style: {
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'var(--semi-color-fill-2)'
            }
        },
        content: {
            style: {
                flex: 1
            },
            title: {
                style: {
                    width: '80%',
                    height: '16px',
                    background: 'var(--semi-color-fill-2)',
                    marginBottom: '8px'
                }
            },
            description: {
                style: {
                    width: '60%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)'
                }
            }
        }
    }
};